import React from "react";
import PropTypes from "prop-types";
import { getAsset } from "../support/asset-import";

const propTypes = {
  iconName: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const Icon = ({ iconName, className }) => (
  <img src={getAsset(iconName)} className={className} alt={iconName} />
);

Icon.propTypes = propTypes;

Icon.defaultProps = { className: "" };

export default Icon;
